// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.growth.listing.RentalManagerGrowthGetCompStatsForListingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetCompStatsForListingResponseWebDto, ListingAlias } from '../..';

interface GetCompStatsParams {
  listingAlias: ListingAlias;
}

export const RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_Path =
  '/api/web/v1/users/growth/listing/getCompStats';

/**
 * Get comp stats (views/inquiries) for a listing and its similar floorplans
 */
export const RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats = (
  getParams: GetCompStatsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetCompStatsParams, never, GetCompStatsForListingResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerGrowthGetCompStatsForListingWebApiHandler_getCompStats_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
